/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Service_UnreachableInputs */

const fr_reference_service_unreachable = /** @type {(inputs: Reference_Service_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de joindre BusinessFlow. Vérifiez votre connexion.`)
};

const en_reference_service_unreachable = /** @type {(inputs: Reference_Service_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach BusinessFlow. Check your connection.`)
};

/**
* | output |
* | --- |
* | "Could not reach BusinessFlow. Check your connection." |
*
* @param {Reference_Service_UnreachableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reference_service_unreachable = /** @type {((inputs?: Reference_Service_UnreachableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Service_UnreachableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reference_service_unreachable(inputs)
	return fr_reference_service_unreachable(inputs)
});